import { render, staticRenderFns } from "./d-menu.vue?vue&type=template&id=9a20328c&scoped=true&"
import script from "./d-menu.vue?vue&type=script&lang=js&"
export * from "./d-menu.vue?vue&type=script&lang=js&"
import style0 from "./d-menu.vue?vue&type=style&index=0&id=9a20328c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a20328c",
  null
  
)

export default component.exports